import { useDispatch } from 'react-redux';

import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';
import { api } from '~/redux/api/createApi';
import { TAG_BY_ACTIVITY_LOG } from '~/redux/api/endpoints/tickets';
import { TagType } from '~/redux/api/TagType';
import { Uuid } from '~/types/Uuid';

interface Props {
  ticketId: Uuid;
}
export function useActivityLogUpdater({ ticketId }: Props) {
  const dispatch = useDispatch();
  const isEsignatureRevampEnabled = useFlag(FlagType.EsignatureV2Revamp);

  function updateActivityLog() {
    dispatch(api.util.invalidateTags([TAG_BY_ACTIVITY_LOG]));
    if (isEsignatureRevampEnabled) {
      dispatch(
        api.util.invalidateTags([
          {
            type: TagType.EsignatureActivities,
            id: ticketId,
          },
        ]),
      );
    }
  }

  return updateActivityLog;
}
